import React, {createContext} from "react";
import {APIContext} from "./api_hook";
// Creating the context
export const ViewContext = createContext<any>(null);

type ViewContextType = {
    // Add the types of the context here
    children: React.ReactNode;
};

const dummy_views =
    [
        {
            "id": "971056220392259585",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:27:20.693141",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971056387778084865",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:28:11.775711",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971056583803535361",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:29:11.597817",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971056780571574273",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:30:11.647212",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971056976589389825",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:31:11.466815",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971057173726920705",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:32:11.628519",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971057372559278081",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:33:12.307220",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971057567490342913",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:34:11.795395",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971057763114221569",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:35:11.495222",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971057960389902337",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:36:11.699057",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971058156874006529",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:37:11.660976",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971058354058330113",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:38:11.836780",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971058549684666369",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:39:11.537433",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971058746561003521",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:40:11.619433",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971058943244075009",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:41:11.642165",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971059139326181377",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:42:11.481480",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971059336552939521",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:43:11.670602",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971059532983304193",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:44:11.616296",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971059729254383617",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:45:11.513250",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971059925820506113",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:46:11.500716",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971060122515406849",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:47:11.527281",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971060319366250497",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:48:11.601369",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971060516018061313",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:49:11.614766",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971060712187166721",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:50:11.480881",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971060909079101441",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:51:11.567425",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971061105305616385",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:52:11.451101",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971061302413426689",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:53:11.603505",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971061498723991553",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:54:11.512847",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971061695554748417",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:55:11.580502",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971061893882544129",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:56:12.105736",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971062089487417345",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:57:11.799459",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971062285173522433",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:58:11.517943",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971062482084233217",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 21:59:11.610520",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971062678701211649",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 22:00:11.613359",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971062875059519489",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 22:01:11.537100",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971063071930056705",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 22:02:11.615606",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971063268921540609",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 22:03:11.734184",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971063465362489345",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 22:04:11.683155",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971063661969211393",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 22:05:11.682662",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971063858137333761",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 22:06:11.548473",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971064055036051457",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 22:07:11.635903",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971064251461435393",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 22:08:11.581448",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971064448382500865",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 22:09:11.676905",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971064644682547201",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 22:10:11.583167",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971064841083584513",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 22:11:11.519960",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971065038278262785",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 22:12:11.698955",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971065234450612225",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 22:13:11.565597",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971065431112679425",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 22:14:11.582534",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971065627998945281",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 22:15:11.667392",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971065824774193153",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 22:16:11.718497",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971066020538122241",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 22:17:11.460822",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971066217931833345",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 22:18:11.699865",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971066413680492545",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 22:19:11.438299",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971066610976882689",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 22:20:11.648600",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971066807998513153",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 22:21:11.774688",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971067003373944833",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 22:22:11.398573",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971067200219054081",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 22:23:11.470837",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971067397716049921",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 22:24:11.742337",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971067593552330753",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 22:25:11.506440",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971067791794339841",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 22:26:12.005488",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971067987628982273",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 22:27:11.769370",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        },
        {
            "id": "971068011953782785",
            "test": "971056204799541249",
            "view_count": 1,
            "created_at": "2024-05-22 22:27:19.192339",
            "statistics": {
                "commentCount": "0",
                "dislikeCount": "0",
                "favoriteCount": "0",
                "likeCount": "0",
                "viewCount": "1"
            }
        }
    ]

const ViewProvider = (props: ViewContextType) => {
    const {children} = props;
    const {fetch_api} = React.useContext(APIContext);
    const [loading, setLoading] = React.useState<boolean>(false);
    const getViewCountForTest = async (test_id: string) => {
        // return dummy_views;
        setLoading(true);
        const options = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        };
        const resp = await fetch_api(`/api/viewcount/?test=${test_id}`, options);
        // console.log({resp})
        setLoading(false);
        return resp;
    };

    const getViewCount = async (viewcount_id: string) => {
        setLoading(true);
        const options = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        };
        const resp = await fetch_api(`/api/viewcount/${viewcount_id}/`, options);
        setLoading(false);
        return resp;
    };


    const deleteViewCount = async (viewcount_id: string) => {
        setLoading(true);
        const options = {
            method: "DELETE",
        };
        const resp = await fetch_api(`/api/viewcount/${viewcount_id}/`, options);
        setLoading(false);
        return resp;
    }

    return (
        <ViewContext.Provider
            value={{
                loading,
                getViewCountForTest,
                getViewCount,
                deleteViewCount,
            }}
        >
            {children}
        </ViewContext.Provider>
    );
};
export default ViewProvider;
